<template>
  <div class="top_bar">
    <a-space>
      <template v-if="mallGroupList?.length">
        <!-- 选择店群 -->
        <div>
          <span class="label">请选择店群: </span>
          <a-select
            ref="select"
            v-model:value="GroupId"
            style="width: 170px"
            placeholder="请选择店群"
            @change="changeMallGroup"
          >
            <a-select-option :value="item.GroupId" v-for="item in mallGroupList" :key="item.Id">{{item.GroupName}}</a-select-option>
          </a-select>
        </div>
      </template>
      <!-- 创建店群 -->
      <a-popover  title="创建店群" trigger="click" placement="bottom">
        <template #content>
          <a-space>
            <a-input v-model:value="createGroupName" placeholder="请输入店群名称" allowClear/>
            <a-button type='primary' @click="createGroup">确认创建</a-button>
          </a-space>
        </template>
        <a-button type="primary" :loading='loading'>创建店群</a-button>
      </a-popover>
      <template v-if="mallGroupList?.length">
        <!-- 获取邀请码 -->
        <a-button @click="updataInviteCode" ghost type='primary' :loading='loading'>复制邀请码</a-button>
        <!-- 加入店群 -->
        <a-popover title="加入店群" trigger="click" placement="bottom">
          <template #content>
            <a-space direction='vertical'>
              <a-tag color='red'>提示: 一个店铺最多只能加入【5】个店群</a-tag>
              <a-space>
                <a-input v-model:value="InviteCode" placeholder="请输入邀请码" allowClear/>
                <a-button type='primary' @click="addGroup">确认加入</a-button>
              </a-space>
            </a-space>
          </template>
          <a-button ghost type='primary' :loading='loading'>加入店群</a-button>
        </a-popover>
        <!-- 删除店群 -->
        <a-popconfirm
          v-if="mallGroupList?.length"
          :title="getDelGroupTip"
          ok-text="确认"
          cancel-text="取消"
          @confirm="delGroup"
          placement="bottom"
        >
          <a-button danger type='primary' :loading='loading'>解散店群</a-button>
        </a-popconfirm>
      </template>
    </a-space>
  </div>
</template>

<script>
import handler from './handler'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { COU_Sleep, COU_CopyToClipboard } from '@/utils/co_util'
import { Service_GetZfbMemberInfo }from '@/service/platform_config'
export default {
  props:{
    loading:Boolean
  },
  data() {
    return {
      createGroupName: '', // 创建店群的名称
      InviteCode:'', // 加入店群的邀请码
    }
  },
  computed:{
    ...mapGetters({
      mallGroupList: 'mall_group/mallGroupList',
      GroupId: 'mall_group/GroupId'
    }),
    getDelGroupTip() {
      var info = this.mallGroupList.find(item =>{
        return item.GroupId == this.GroupId
      })
      return `您确定要解散店群【${info?.GroupName}】吗？`
    }
  },
  methods:{
    ...mapActions({
      GetMallGroupList: 'mall_group/GetMallGroupList',
    }),
    ...mapMutations({
      setGroupId: 'mall_group/setGroupId',
      setCheckMall: 'mall_group/setCheckMall',
    }),
    async getMallGroupList(isCreate) {
      var { msg, success} = await this.GetMallGroupList()
      if(!success) return this.$message.warn(msg)
      // 如果有创建新的店群默认选中第一个
      if(isCreate) this.setGroupId(this.mallGroupList[0].GroupId)
      this.$emit('updataList',this.GroupId)
    }, 
    async createGroup() {
      if(!this.createGroupName) return this.$message.warn('请先输入店铺名称,再进行创建!')
      var {msg , success} = await handler.CreateGroup(this.createGroupName)
      // 创建失败了就做好提示原因
      if(!success) return this.$message.warn(msg)
      // 创建成功, 提示创建成功, 刷新店群列表.
      this.$message.success('创建成功!')
      this.getMallGroupList(true)
    },
    //切换店群的时候重新刷新列表
    changeMallGroup(val) {
      this.setGroupId(val)
      this.$emit('updataList',this.GroupId,true)
    },
    // 邀请码
    async updataInviteCode() {
      // 刷新邀请码(获取最新的邀请码)
      var {msg, success, InviteCode} = await handler.GetInviteCode(this.GroupId)
      // 如果获取不到邀请码, 其实错误原因
      if(!success) return this.$message.warn(msg)
      // 获取成功, 复制邀请码, 并做好提示
      COU_CopyToClipboard(InviteCode)
      this.$message.success(`复制邀请码【${InviteCode}】成功`)
    },
    // 加入店群 
    async addGroup() {
      if(!this.InviteCode) return this.$message.warn('请输入邀请码!')
      var {msg , success} =  await handler.AddGroup(this.InviteCode)
      // 加入失败提示
      if(!success) return this.$message.warn(msg)
      // 加入成功,重新获取店群列表 .刷新店铺列表, 并做好提示
      // 这个是vuex里面的所以需要等待他设置groupId
      await this.GetMallGroupList()
      this.$emit('updataList', this.GroupId, true)
      this.$message.success('加入成功!')
    },
    // 解散店群
    async delGroup() {
      var {msg,success} = await handler.DelGroup(this.GroupId)
      // 删除失败提示
      if(!success) return this.$message.warn(msg)
      // 删除成功, 重新获取店群列表 , 重新设置GroupId
      this.setGroupId('')
      this.setCheckMall({})
      this.getMallGroupList()
      this.$message.success('解散店群成功!')
      this.$emit('updataList', null)
    },
  // 检查当前授权的ks账号是否是这个店群的主店铺
    CheckCurrentMemberIsMainInMallGroupList() {
      var memberInfo = Service_GetZfbMemberInfo()
      var info = this.mallGroupList.find(item =>{
        return item.ShopId == memberInfo.shop_id && item.IsMain
      })
      return info
    },
    async init() {
      await COU_Sleep(500)
      this.$emit('updataList',this.GroupId)
    }
  },
  mounted() {
    this.init()
  },
  watch:{
    GroupId(newVal, oldVal) {
      if(newVal != oldVal) this.$emit('updataList',this.GroupId,true)
    }
  }
}
</script>